module.exports = __webpack_public_path__ + "static/the-idea-factory-523b606bdd0890656a851d136eceaf42.jpg";